import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Label } from 'semantic-ui-react';
import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';
import { kindFormatted } from '../../utilities/productUtil';

const IneligiblePurchasesListRow = () => guaranteePurchase => {
  const {
    id,
    kind,
    expireGuarantee,
    guaranteedAt,
    partner,
    guaranteeOffer: {
      guaranteeStatus,
      leftLot,
      daysSelected,
      milesSelected,
      guaranteePrice,
      paymentKind,
      externalId,
      product,
      vehicleInformation,
      auctionInformation,
    },
  } = guaranteePurchase;

  const {
    vin, make, model, odometerReading, year,
  } = vehicleInformation || {};

  const {
    locationInitials,
    saleNumber,
    runNumber,
    laneNumber,
    vehiclePurchasePrice,
    dealerNumber,
  } = auctionInformation || {};

  const getProductName = prod => (prod
    ? prod.name
    : `${kindFormatted(kind)} (${daysSelected} D ${milesSelected} M)`);

  const vehicle = `${year} ${make} ${model}`;
  const currencyProps = price => ({
    currency: 'USD',
    style: 'currency',
    minimumFractionDigits: 0,
    value: price,
  });

  const auctionInfo = [
    locationInitials,
    saleNumber,
    laneNumber,
    runNumber,
  ].join(' / ');

  const labels = [];
  if (leftLot) {
    labels.push(
      <Label key='left lot' color='red' horizontal>
        Left Lot
      </Label>
    );
  }
  if (expireGuarantee) {
    labels.push(
      <Label key='Expired' color='red' horizontal>
        Expired
      </Label>
    );
  }

  return (
    <Table.Row key={id}>
      <Table.Cell>
        {vin} {labels}
      </Table.Cell>
      <Table.Cell>{externalId}</Table.Cell>
      <Table.Cell>{dateTimeFormatted(utcMoment(guaranteedAt))}</Table.Cell>
      <Table.Cell>{dealerNumber}</Table.Cell>
      <Table.Cell>{auctionInfo}</Table.Cell>
      <Table.Cell>{vehicle}</Table.Cell>
      <Table.Cell>{odometerReading}</Table.Cell>
      <Table.Cell>
        {React.createElement(
          FormattedNumber,
          currencyProps(vehiclePurchasePrice)
        )}
      </Table.Cell>
      <Table.Cell>{guaranteeStatus}</Table.Cell>
      <Table.Cell>{getProductName(product)}</Table.Cell>
      <Table.Cell>
        {React.createElement(FormattedNumber, currencyProps(guaranteePrice))}
      </Table.Cell>
      <Table.Cell>{partner}</Table.Cell>
      <Table.Cell>{paymentKind}</Table.Cell>
    </Table.Row>
  );
};

export default IneligiblePurchasesListRow;
